import React, { useEffect, useState } from "react";
import "./App.css";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ProblemSection } from "./components/ProblemSection";
import { ROICalculator } from "./components/ROICalculator";
import { Services } from "./components/Services";
import { WhyChoose } from "./components/WhyChoose";
import { BeforeAfter } from "./components/BeforeAfter";
import { Process } from "./components/Process";
import { Pricing } from "./components/Pricing";
import { Portfolio } from "./components/Portfolio";
import { LeadFormSection } from "./components/LeadFormSection";
import { LeadMagnet } from "./components/LeadMagnet";
import { Testimonials } from "./components/Testimonials";
import { FAQ } from "./components/FAQ";
import { Scarcity } from "./components/Scarcity";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { MobileCallButton } from "./components/MobileCallButton";
import { ScrollProgress } from "./components/effects/ScrollProgress";
import { BackToTop } from "./components/effects/BackToTop";
import { CursorTrail } from "./components/effects/CursorTrail";
import { ExitIntent } from "./components/effects/ExitIntent";
import { VisitorCounter } from "./components/effects/VisitorCounter";
import { MobileStickyCTA } from "./components/effects/MobileStickyCTA";
import { CalendlyEmbed } from "./components/effects/CalendlyEmbed";

function App() {
  const [calendlyOpen, setCalendlyOpen] = useState(false);

  const goConsult = () => {
    const el = document.getElementById("consultation");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const openCalendly = () => setCalendlyOpen(true);

  useEffect(() => {
    document.title = "Divy Shetty — Premium Web Developer for Indian Businesses";
  }, []);

  return (
    <div className="App font-body bg-black text-white" data-testid="app-root">
      <ScrollProgress />
      <CursorTrail />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fff",
          },
        }}
      />
      <Navbar onCTAClick={goConsult} onScheduleClick={openCalendly} />
      <main>
        <Hero onPrimary={goConsult} onSecondary={openCalendly} />
        <ProblemSection />
        <ROICalculator onCTA={goConsult} />
        <Services onCTA={goConsult} />
        <WhyChoose />
        <LeadMagnet />
        <BeforeAfter />
        <Process />
        <Pricing onCTA={goConsult} />
        <Portfolio onCTA={goConsult} />
        <LeadFormSection onScheduleClick={openCalendly} />
        <Testimonials />
        <FAQ />
        <Scarcity onCTA={goConsult} onScheduleClick={openCalendly} />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <MobileCallButton />
      <MobileStickyCTA />
      <VisitorCounter />
      <BackToTop />
      <ExitIntent onCTA={goConsult} />
      <CalendlyEmbed open={calendlyOpen} onClose={() => setCalendlyOpen(false)} />
    </div>
  );
}

export default App;
